import { Box, Theme, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../common/customTable'
import { AlternativeAssetTableProps, AssetAllocationTable, FundHouseComponentProps, FundHouseTable } from '../../../../redux-store/types/alternative'
import { SortingObj } from '../../types'
import _ from 'lodash'
import { FundHouseTableComponent, fundHouseTableHeader } from './AlternativeTable'

function FundHouse(props: FundHouseComponentProps) {

    const { isLoading, completeData, onPageChange, sortingObj, handletableSorting, totalPage, onRowsPerPageChange, paginationObj } = props

    //state
    const [originTableData, setOriginTableData] = useState<FundHouseTable[]>([])

    useEffect(() => {
        if (completeData.length > 0) {
            setOriginTableData([...completeData])
        }
    }, [completeData])



    return (
        <Box sx={(theme: Theme) => ({
            borderRadius: '20px',
            padding: '25px 30px 45px 30px',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
            background: theme.palette.common.white,
            height: '100%'
        })}>
            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                <Typography variant="h2" sx={{
                    marginBottom: '40px'
                }}>Fund House Performance</Typography>

            </Box>
            <Box mt={'20px'} width={'100%'}>
                <CustomTable
                    loadingRowsNum={3}
                    isLoading={isLoading}
                    tableBody={
                        <FundHouseTableComponent
                            tableBodyData={originTableData || []}
                            isLoading={isLoading}
                        />
                    }
                    tableData={originTableData || []}
                    tableBodyLoaderRowCustomStyles={{
                        '& td:first-of-type': {
                            paddingLeft: "0px"
                        },

                    }}
                    tableHeaderData={fundHouseTableHeader}
                    tableHeadRowCustomStyles={{
                        '& th:first-of-type': {
                            paddingLeft: "0px"
                        }
                    }}
                    handleSort={handletableSorting as any}
                    tableBodyCustomStyles={{
                        '& tr:last-child td': {
                            border: 0
                        }
                    }}
                    tableDataCount={totalPage || 0}
                    isPaginationVisible={true}
                    order={sortingObj.order}
                    orderBy={sortingObj.orderBy}
                    rowsPerPage={paginationObj.rowsPerPage}
                    currentPage={paginationObj.currentPage - 1}
                    rowsPerPageOptions={[5, 10, 15]}
                    handlePageChange={onPageChange as any}
                    handleRowsPerPageChange={onRowsPerPageChange as any}
                />
            </Box>
        </Box>
    )
}

export default FundHouse